module.exports = __webpack_public_path__ + "img/59.8.TSS.102e2ee5.png";